import * as ActionTypes from "./actionTypes";

export function showModal({
  title = null,
  body = null,
  showCancel = false,
  showConfirm = true,
  showClose = true,
  confirmLabel = null,
  cancelLabel = null,
  onConfirm = null,
}) {
  return (dispatch, getstate) => {
    window.document.body.classList.add("modal-open");
    dispatch({
      type: ActionTypes.SHOW_MODAL,
      payload: {
        title: title,
        body: body,
        showConfirm: showConfirm,
        showCancel: showCancel,
        showClose: showClose,
        confirmLabel: confirmLabel,
        cancelLabel: cancelLabel,
        onConfirm: onConfirm,
      },
    });
  };
}

export function hideModal() {
  return dispatch => {
    document.body.classList.remove("modal-open");
    dispatch({ type: ActionTypes.HIDE_MODAL });
  };
}



// WEBPACK FOOTER //
// ./src/actions/modalActions.js